  <ng-container [ngSwitch]="title" >
    <!-- mark as Active -->
    <div class="modal-container" *ngSwitchCase="enumPopUpTitles.MARK_AS_ACTIVE">
      <div class="modal-header border-0 justify-content-center">
        <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
      </div>
      <div class="modal-body">
        <div class="text-center">
          <p *ngIf="pageType !=='multilevel'" class="m-0 text-light-gray popup-secondary-text my-auto">You are about to make a {{pageType}} active.</p>
          <!-- <p class="m-0 text-light-gray" *ngIf="pageType !=='multilevel'"></p> -->
          <p class="m-0 text-light-gray popup-secondary-text"> Are you sure you want to mark<br />
            <span class="as-active text-break text-primary-color popup-secondary-text">{{fullName | titlecase }}</span> as
            active?
          </p>
        </div>
      </div>
      <div class="modal-footer border-0 justify-content-center">
        <div class="m-0 d-flex gap-3">
          <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-info popup-button'" class="" (click)="activeModal.close({title,confirm:false})" [buttonLable]="enumButtonName.CANCEL"></app-button>
          <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-primary popup-button'" class="" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.CONFIRM" (click)="activeModal.close('Close click')"></app-button>
        </div>
      </div>
    </div>
    <!-- Mark as active end  -->

    <!-- mark as InActive -->
    <div class="modal-container" *ngSwitchCase="enumPopUpTitles.MARK_AS_INACTIVE">
      <div class="modal-header border-0 justify-content-center">
        <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
      </div>
      <div class="modal-body">
        <div class="text-center">
          <p *ngIf="pageType !=='multilevel'" class="m-0 text-light-gray popup-secondary-text">You are about to make a {{pageType}} inactive.</p>
          <!-- <p class="m-0 text-light-gray" *ngIf="pageType !=='multilevel'"></p> -->
          <p class="m-0 text-light-gray popup-secondary-text"> Are you sure you want to mark<br />
            <span class="as-active text-break text-primary-color popup-secondary-text">{{fullName | titlecase }}</span> as
            inactive?
          </p>
        </div>
      </div>
      <div class="modal-footer border-0 justify-content-center">
        <div class="m-0 d-flex gap-3">
          <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-info popup-button '" class="" (click)="activeModal.close({title,confirm:false})" [buttonLable]="enumButtonName.CANCEL"></app-button>
          <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-primary popup-button'" class="" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.CONFIRM" (click)="activeModal.close('Close click')"></app-button>
        </div>
      </div>
    </div>
    <!-- Mark as Inactive end  -->

    <!-- Delete PopUp start  -->
    <div class="modal-container" *ngSwitchCase="enumPopUpTitles.DELETE">
      <div *ngIf="!deleteForAdmin">
        <div class="modal-header border-0 justify-content-center">
          <h1 class="modal-title text-center text-danger-color">{{title}}</h1>
        </div>
        <div class="modal-body">
          <div class="text-center">
            <p *ngIf="pageType !=='multilevel' && pageType !=='addresses' && pageType !=='contacts' && pageType !=='vendor-contacts'" class="m-0 text-light-gray popup-secondary-text">You are about to delete {{articleForPageType}} {{pageType}} record.</p>
            <!-- <p class="m-0 text-light-gray" *ngIf="pageType !=='multilevel'"></p> -->
            <p class="m-0 text-light-gray popup-secondary-text"> Are you sure you want to delete
              <span class="as-active text-break text-primary-color popup-secondary-text my-auto">{{fullName}}</span><br /> 
              <!-- from the {{pageType=='multilevel'?'':pageType}} list? -->
              from the  {{ pageType == 'company' ? 'company' : pageType == 'multilevel' ? '' : pageType }} list?
            </p>
          </div>
        </div>
        <div class="modal-footer border-0 justify-content-center">
          <div class="m-0 d-flex gap-3">
            <app-button [buttonType]="'button'" class=""  [button_2]="true" [buttonClass]="'button button-info popup-button'" (click)="activeModal.close({title,confirm:false})"[buttonLable]="enumButtonName.CANCEL"></app-button>
            <app-button *ngIf=" pageType !=='addresses'"
             [buttonType]="'button'" class="" [button_2]="true" [buttonClass]="'button button-danger popup-button'" (click)="deletePopup()" [buttonLable]="enumButtonName.DELETE"></app-button>
            <app-button *ngIf=" pageType =='addresses'"
             [buttonType]="'button'" class="" [button_2]="true" [buttonClass]="'button button-danger popup-button'" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.DELETE"></app-button>

          </div>
        </div>
      </div>
      <!-- delete confirmation popup for admin And Non-Admin start -->
      <ng-container *ngIf="deleteForAdmin">
        <div class="modal-header border-0 justify-content-center">
          <h1 class="modal-title text-center text-danger-color">{{title}}</h1>
        </div>
        <div class="modal-body">
          <div class="text-center">
            <p class="m-0 text-light-gray popup-secondary-text text-truncate my-auto">{{ResMsgFromCompanyOrContact}}</p>
          </div>
        </div>
        <div class="modal-footer border-0 justify-content-center">
          <div class=" m-0 d-flex">
            <app-button [buttonType]="'button'" class=""  [button_2]="true" [buttonClass]="'button button-info popup-button'" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.OKAY"></app-button>
          </div>
        </div>
      </ng-container>
      <!-- delete confirmation popup for admin And Non-Admin End-->
    </div>
    <!-- Delete PopUp End   -->

    <!-- Password Changed PopUp start -->
    <div class="modal-container" *ngSwitchCase="enumPopUpTitles.PASSWORD_CHANGED">
      <div class="modal-header border-0 justify-content-center">
        <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
      </div>
      <div class="modal-body">
        <div class="text-center">
          <p class="m-0 text-light-gray popup-secondary-text"> Password was changed for <span class="as-active text-break text-primary-color">{{fullName | titlecase }}</span><br /> 
          </p>
        </div>
      </div>
      <div class="modal-footer border-0 justify-content-center">
        <div class="m-0 d-flex">
          <app-button type="button" [buttonClass]="'button button-info popup-button'"  (click)="activeModal.close({title,confirm:false})" [buttonLable]="enumButtonName.OKAY" (click)="activeModal.close('Close click')"></app-button>
        </div>
      </div>
    </div>
    <!-- Password Changed PopUp End -->

    <!-- Reset PopUp start  -->
    <div class="modal-container" *ngSwitchCase="enumPopUpTitles.RESET_PASSWORD">
      <div class="modal-header border-0 justify-content-center">
        <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
      </div>
      <div class="modal-body">
        <div class="text-center">
          <div class="text-start">
            <p class="m-0 text-light-gray p-l-40 font-16">Reset password for <span class="as-active text-break text-primary-color">{{fullName | titlecase}}</span></p>
          </div>
          <p class="m-0 text-light-gray pt-1 font-12">A link was sent to the registered<br>
            email address.
          </p>
        </div>
      </div>
      <div class="modal-footer border-0 justify-content-center">
        <div class="d-flex">
          <app-button type="button" [buttonClass]="'button button-info popup-button'"  (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.OKAY" (click)="activeModal.close('Close click')"></app-button>
        </div>
      </div>
    </div>
    <!-- Reset PopUp end  -->

    <!-- FAVOURITE_DOCKS start  -->
    <div class="modal-container" *ngSwitchCase="enumPopUpTitles.FAVOURITE_DOCKS">
      <div class="modal-header border-0 justify-content-center">
        <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
      </div>
      <div class="modal-body">
        <div class="text-center">
          <div class="">
            <p class="m-0 text-light-gray popup-secondary-text">Are you sure want to remove<br>this page from your Favorites dock?
            </p>
          </div>
          
        </div>
      </div>
      <div class="modal-footer border-0 justify-content-center">
        <div class="m-0 d-flex gap-3">
          <app-button  (click)="activeModal.close({title,confirm:false})" [buttonLable]="enumButtonName.NO" [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button popup-button button-info '" ></app-button>
          <app-button  (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.YES" [buttonType]="'button'" [button_2]="true" [buttonClass]="'button popup-button button-danger'"></app-button>

        </div>
      </div>
    </div>
    <!-- FAVOURITE_DOCKS end  -->
    <!-- Take all permission start  -->
    <div class="modal-container" *ngSwitchCase="enumPopUpTitles.TAKEPERMISSION">
      <div class="modal-header border-0 justify-content-center">
        <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
      </div>
      <div class="modal-body">
        <div class="text-center">
          <p class="m-0 text-light-gray popup-secondary-text">Are you sure you want to Take <br>
            all permissions from ? <br>
            This will take all the administrative rights from the role.
          </p>
        </div>
      </div>
      <div class="modal-footer border-0 justify-content-center">
        <div class="d-flex gap-3 m-0">
          <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-info popup-button'" (click)="activeModal.close({title,confirm:false})" [buttonLable]="enumButtonName.CANCEL"></app-button>
          <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-primary popup-button'" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.CONFIRM"></app-button>
        </div>
      </div>
    </div>
    <!-- Take all permission PopUp end  -->

    <!--  grant permission PopUp end  -->
    <div class="modal-container" *ngSwitchCase="enumPopUpTitles.GRANTPERMISSION">
      <div class="modal-header border-0 justify-content-center">
        <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
      </div>
      <div class="modal-body">
        <div class="text-center">
          <p class="m-0 text-light-gray popup-secondary-text">Are you sure you want to grant <br>
            all permissions?<br>
            This will give the role all administrative rights.
          </p>
        </div>
      </div>
      <div class="modal-footer border-0 justify-content-center">
        <div class="m-0 d-flex gap-3">
          <app-button [buttonType]="'button'" class="" [button_2]="true" [buttonClass]="'button button-info popup-button'" (click)="activeModal.close({title,confirm:false})" [buttonLable]="enumButtonName.CANCEL"></app-button>
          <app-button [buttonType]="'button'" class=""  [button_2]="true" [buttonClass]="'button button-primary popup-button'" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.CONFIRM"></app-button>
        </div>
      </div>
    </div>
    <!-- grant permission PopUp end  -->
    <!-- Restore PopUp Start -->

         <div class="modal-container" *ngSwitchCase="enumPopUpTitles.RESTORE">
      <div class="modal-header border-0 justify-content-center">
        <h1 class="modal-title text-center text-primary-color">{{enumPopUpTitles.RESTORE}}</h1>
      </div>
      <div class="modal-body">
        <div class="text-center">
          <p class="m-0 text-light-gray popup-secondary-text">
            Are you sure you want to restore <span class="text-primary-color popup-secondary-text ">{{fullName}}</span> <br>
          from the {{title=='company'?'company':title}} list?
          </p>
        </div>
      </div>
      <div class="modal-footer border-0 justify-content-center">
        <div class="m-0 d-flex gap-3">
          <app-button [buttonType]="'button'" class="" [button_2]="true" [buttonClass]="'button button-info popup-button'" (click)="activeModal.close({title,confirm:false})" [buttonLable]="enumButtonName.CANCEL"></app-button>
          <app-button [buttonType]="'button'" class=""  [button_2]="true" [buttonClass]="'button button-primary popup-button'" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.RESTORE"></app-button>
        </div>
      </div>
    </div>

    <!-- Restore PopUp end  -->
    <!-- Company Delete PopUp end  -->
     
         <div class="modal-container" *ngSwitchCase="enumPopUpTitles.APPROVE_DELETION">
      <div class="modal-header border-0 justify-content-center">
        <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
      </div>
      <div class="modal-body">
        <div class="text-center">
         <p class="popup-secondary-text text-light-gray">You are about to permanently delete a {{title}} record <br> 
        This cannot be undone<br>
        Are you sure you want to delete <span class="text-primary-color popup-secondary-text">{{fullName}}</span> <br>
        from the {{title=='company'?'company':title}} list?
      </p>

        </div>
      </div>
      <div class="modal-footer border-0 justify-content-center">
        <div class="m-0 d-flex gap-3">
          <app-button [buttonType]="'button'" class="" [button_2]="true" [buttonClass]="'button button-info popup-button'" (click)="activeModal.close({title,confirm:false})" [buttonLable]="enumButtonName.CANCEL"></app-button>
          <app-button [buttonType]="'button'" class=""  [button_2]="true" [buttonClass]="'button button-primary popup-button'" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.APPROVEDELETION"></app-button>
        </div>
      </div>
    </div>

    <!-- Compant Delete PopUp end  -->

    <!--  UNSAVECHANGES PopUp end  -->
    <div class="modal-container" *ngSwitchCase="enumPopUpTitles.UNSAVECHANGES">
      <div class="modal-header border-0 justify-content-center">
        <h1 class="modal-title mt-3 text-center text-primary-color">{{title}}</h1>
      </div>
      <div class="modal-body">
        <div class="text-center">
          <p class="popup-secondary-textfont-16">Your changes have not been saved.<br>
            Do you want to save changes<br>
            before closing?
          </p>
        </div>
      </div>
      <div class="modal-footer border-0 justify-content-center">
        <div class="m-0 d-flex gap-3">
          <app-button [buttonType]="'button'" class="" [button_2]="true" [buttonClass]="'button button-danger popup-button'" (click)="activeModal.close({title,confirm:false})" [buttonLable]="enumButtonName.CLOSE_TAB"></app-button>
          <app-button [buttonType]="'button'" class="" [button_2]="true" [buttonClass]="'button button-primary  popup-button'" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.SAVE"></app-button>
        </div>
      </div>
    </div>

    <!--  UNSAVECHANGES PopUp end  -->


    <!--  SaveChanges PopUp start -->
    <div class="modal-container" *ngSwitchCase="enumPopUpTitles.SAVECHANGES">
      <div class="modal-header border-0 justify-content-center">
        <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
      </div>
      <div class="modal-body">
        <div class="text-center">
          <p class="m-0 text-light-gray popup-secondary-text">Are you sure you want to save these changes?</p>
        </div>
      </div>
      <div class="modal-footer border-0 justify-content-center">
        <div class="m-0 d-flex gap-3">
          <app-button [buttonType]="'button'" class="" [button_2]="true" [buttonClass]="'button button-info popup-button '" (click)="activeModal.close({title,confirm:false})" [buttonLable]="enumButtonName.NO"></app-button>
          <app-button [buttonType]="'button'" class="" [button_2]="true" [buttonClass]="'button button-primary popup-button '" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.YES"></app-button>
        </div>
      </div>
    </div>
    <!-- SaveChanges PopUp end  -->


    <!-- mark as Active -->
    <div class="modal-container" *ngSwitchCase="enumPopUpTitles.REPLACE_PRIMARY_CONTACT">
      <div class="modal-header border-0 justify-content-center">
        <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
      </div>
      <div class="modal-body">
        <div class="text-center">
          <p  class="m-0 text-light-gray popup-secondary-text">
            There is already a primary contact for this company.<br>
            Do you want to replace the current<br>
            primary contact with this one?</p>
        </div>
      </div>
      <div class="modal-footer border-0 justify-content-center">
        <div class="m-0 d-flex gap-3">
          <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-info popup-button'" class="" (click)="activeModal.close({title,confirm:false});closedPopup()" [buttonLable]="enumButtonName.CANCEL"></app-button>
          <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-primary popup-button'" class="" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.CONFIRM" (click)="activeModal.close('Close click')"></app-button>
        </div>
      </div>
    </div>
    <!-- Mark as active end  -->

        <!--  SaveChanges PopUp start -->
        <div class="modal-container" *ngSwitchCase="enumPopUpTitles.POPUP_VALUE">
          <div class="modal-header border-0 justify-content-center">
            <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
          </div>
          <div class="modal-body">
            <div class="text-center">
              <p class="m-0 text-light-gray popup-secondary-text">{{message}}</p>
            </div>
          </div>
          <div class="modal-footer border-0 justify-content-center">
            <div class="m-0 d-flex">
              <app-button [buttonType]="'button'" class="" [button_2]="true" [buttonClass]="'button button-primary popup-button'" (click)="activeModal.close()" [buttonLable]="enumButtonName.OKAY"></app-button>
            </div>
          </div>
        </div>
        <!-- SaveChanges PopUp end  -->
            <!--Delete templateId -->
            <div class="modal-container" *ngSwitchCase="enumPopUpTitles.DELETE_TEMPLATEID">
              <div class="modal-header border-0 justify-content-center">
                <h1 class="modal-title text-center text-danger-color">{{title}}</h1>
              </div>
              <div class="modal-body">
                <div class="text-center">
                  <p class="m-0 text-light-gray popup-secondary-text">
                    You are about to delete a mapping template. <br>
                    Are you sure you want to delete <span class="font-16  text-break text-primary-color text-truncate">{{templateName}}</span><br>
                    from the list? This cannot be undone.
                    </p>
                </div>
              </div>
              <div class="modal-footer border-0 justify-content-center">
                <div class="m-0 d-flex gap-3">
                  <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-info popup-button'" class="" (click)="activeModal.close({title,confirm:false})" [buttonLable]="enumButtonName.CANCEL"></app-button>
                  <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-danger popup-button'" class="" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.DELETE"(click)="activeModal.close('Close click')"></app-button>
                 </div>
              </div>
            </div>
            <!-- Delete templateId-->
            <!-- *edit quicke notes* -->
            <div class="modal-container" *ngSwitchCase="enumPopUpTitles.EDIT_QUICKNOTES">
              <div class="modal-header border-0 justify-content-start">
                <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
              </div>
              <div class="modal-body">
                <textarea class="form-control font-16 text-light-gray"  rows="6"  [ngModel]="quickNotes.notes" (ngModelChange) ='quickNotes.notes =$event'></textarea>
              </div>
              <div class="modal-footer border-0 justify-content-end">
                <div class="m-0 d-flex gap-3">
                  <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-info popup-button'" class="" (click)="activeModal.close({title,confirm:false})" [buttonLable]="enumButtonName.CANCEL"></app-button>
                  <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-primary popup-button'" class="" (click)="notesUpdate()" [buttonLable]="enumButtonName.SAVE"></app-button>
                 </div>
              </div>
            </div>
            <!-- *edit quicke notes* -->
  <!-- archived companies confirmation popup start-->
   <div class="modal-container" *ngSwitchCase="enumPopUpTitles.ARCHIVED_COMPANIES">
      <div class="modal-header border-0 justify-content-center">
        <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
      </div>
      <div class="modal-body">
        <div class="text-center">
          <p class="m-0 text-light-gray popup-secondary-text">
            You are about to archive a company. <br>
           Are you sure you want to archive <br>
           <span class=" text-break text-primary-color">{{fullName}}</span>?
          </p>
        </div>
      </div>
      <div class="modal-footer border-0 justify-content-center">
         <div class="m-0 d-flex gap-3">
          <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button popup-button button-info'" (click)="activeModal.close({title,confirm:false})" [buttonLable]="enumButtonName.CANCEL"></app-button>
          <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button popup-button button-primary'" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.CONFIRM"></app-button>
         </div>
      </div>
    </div>

    <div class="modal-container" *ngSwitchCase="enumPopUpTitles.UNARCHIVED_COMPANIES">
      <div class="modal-header border-0 justify-content-center">
        <h1 class="modal-title text-center  text-primary-color">{{title}}</h1>
      </div>
      <div class="modal-body">
        <div class="text-center">
          <p class="m-0 text-light-gray popup-secondary-text">
            You are about to unarchive a company. <br>
           Are you sure you want to unarchive <br>
           <span class="text-break text-primary-color">{{fullName}}</span>?
          </p>
        </div>
      </div>
      <div class="modal-footer border-0 justify-content-center">
         <div class="m-0 d-flex gap-3">
          <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-info popup-button'" class="" (click)="activeModal.close({title,confirm:false})" [buttonLable]="enumButtonName.CANCEL"></app-button>
          <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-primary popup-button'" class="" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.CONFIRM"></app-button>
         </div>
      </div>
    </div>

   <!--archived companies confirmation popup end-->
  
  <!--unable archived companies confirmation popup start-->
   <div class="modal-container" *ngSwitchCase="enumPopUpTitles.UNABLE_ARCHIVED_COMPANIES">
    <div class="modal-header border-0 justify-content-center">
       <h1 class="modal-title text-center  text-primary-color">{{title}}</h1>
    </div>
    <div class="modal-body">
      <div class="text-center">
        <p class="m-0 text-light-gray popup-secondary-text">
        Company cannot be archived, <br>
        Company has open sales orders
        </p>
      </div>
    </div>
    <div class="modal-footer border-0 justify-content-center">
      <div class="m-0 d-flex">
       <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-info popup-button'" class="" (click)="activeModal.close({title,confirm:false})" [buttonLable]="enumButtonName.CANCEL"></app-button>
      </div>
    </div>
  </div>
  <!--unable archived companies confirmation popup end-->
  <!--expired offer popup start-->

  <div class="modal-container" *ngSwitchCase="enumPopUpTitles.EXPIRE_OFFER">
    <div class="modal-header border-0 justify-content-center">
      <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
    </div>
    <div class="modal-body">
      <div class="text-center">
        <p class="m-0 text-light-gray popup-secondary-text"> You are about to expire this offer.</p>
        <p class="m-0 text-light-gray popup-secondary-text">
          Are you sure you want to proceed?
        </p>
      </div>
    </div>
    <div class="modal-footer border-0 justify-content-center">
      <div class="m-0 d-flex gap-3">
        <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-info popup-button'" class="" (click)="activeModal.close({title,confirm:false})" [buttonLable]="enumButtonName.CANCEL"></app-button>
        <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-primary popup-button'" class="" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.CONFIRM" (click)="activeModal.close('Close click')"></app-button>
      </div>
    </div>
  </div>
  <!--expired offer popup end-->

  <div class="modal-container" *ngIf="title === enumPopUpTitles.VENDOR_PART_ACTIVE || title === enumPopUpTitles.LINE_ACTIVE">
    <div class="modal-header border-0 justify-content-center">
      <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
    </div>
    <div class="modal-body">
      <div class="text-center">
        <p class="m-0 text-light-gray popup-secondary-text my-auto">You are about to make this {{title == enumPopUpTitles.VENDOR_PART_ACTIVE?'vendor part':'line'}} active.</p>
        <p class="m-0 text-light-gray popup-secondary-text">Please add a new expiration date.</p>
      </div>
      <div class="row justify-content-center pt-3">
        <div class="col-7">
          <app-date-picker 
          [time]="false"
          [inputLabel]="'Enter Expiration Date'"
          [inputValue]="expirationDate"
          (inputValueEmit)="expirationDate = $event"
          [ngClass]="{'border-red':!expirationDate && data?.submit}"
          [minDate]="minDate"
          >
         </app-date-picker>
        </div>
      </div>
    </div>
    <div class="modal-footer border-0 justify-content-center">
      <div class="m-0 d-flex gap-3">
        <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-info popup-button'" class="" (click)="activeModal.close({title,confirm:false})" [buttonLable]="enumButtonName.CANCEL"></app-button>
        <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-primary popup-button'" class="" (click)="onConfirmClick(true)" [buttonLable]="enumButtonName.CONFIRM"></app-button>
      </div>
    </div>
  </div>
  <div class="modal-container" *ngIf="title === enumPopUpTitles.EXPIRE_VENDOR_PART || title === enumPopUpTitles.EXPIRE_LINE">
    <div class="modal-header border-0 justify-content-center">
      <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
    </div>
    <div class="modal-body">
      <div class="text-center">
        <p class="m-0 text-light-gray popup-secondary-text my-auto">You are about to expire this {{title == enumPopUpTitles.EXPIRE_VENDOR_PART?'vendor part':'line'}}.</p>
        <p class="m-0 text-light-gray popup-secondary-text">This will make the expiration date today.</p>
        <p class="m-0 text-light-gray popup-secondary-text">Are you sure you want to proceed?</p>
      </div>
    </div>
    <div class="modal-footer border-0 justify-content-center">
      <div class="m-0 d-flex gap-3">
        <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-info popup-button'" class="" (click)="activeModal.close({title,confirm:false})" [buttonLable]="enumButtonName.CANCEL"></app-button>
        <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-primary popup-button'" class="" (click)="onConfirmClick(true)" [buttonLable]="enumButtonName.CONFIRM"></app-button>
      </div>
    </div>
  </div>
  <div class="modal-container" *ngSwitchCase="enumPopUpTitles.ERROR">
    <div class="modal-header border-0 justify-content-center">
      <h1 class="modal-title text-center text-danger-color">{{title}}</h1>
    </div>
    <div class="modal-body">
      <div class="text-center">
        <p class="m-0 text-light-gray popup-secondary-text">Please select only {{data?.status}}.</p>
      </div>
    </div>
    <div class="modal-footer border-0 justify-content-center">
      <div class="m-0 d-flex">
        <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-info popup-button'" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.OKAY"></app-button>
      </div>
    </div>
  </div>
  <div class="modal-container" *ngSwitchCase="enumPopUpTitles.PLACEONHOLD">
    <div class="modal-header border-0 justify-content-center">
      <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
    </div>
    <div class="modal-body">
      <div class="text-center">
        <p class="m-0 text-light-gray popup-secondary-text">Placing this inventory line on hold will prevent it from being used<br />
          as a new source for any future transactions. <br />
          Are you sure you want to proceed?
        </p>
      </div>
    </div>
    <div class="modal-footer border-0 justify-content-center">
      <div class="m-0 d-flex gap-3">
        <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-info popup-button'" class="" (click)="activeModal.close({title,confirm:false})" [buttonLable]="enumButtonName.CANCEL"></app-button>
        <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-primary popup-button'" class="" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.CONFIRM" (click)="activeModal.close('Close click')"></app-button>
      </div>
    </div>
  </div>
  <div class="modal-container" *ngSwitchCase="enumPopUpTitles.DELETE_CATEGORY">
    <div class="modal-header border-0 justify-content-center">
      <h1 class="modal-title text-center text-danger-color">{{title}}</h1>
    </div>
    <div class="modal-body">
      <div class="text-center">
        <p class="m-0 text-light-gray popup-secondary-text text-truncate my-auto">Are you sure you want to delete this category? <br>
          Any subcategories it may have will also be deleted.
        </p>
      </div>
    </div>
    <div class="modal-footer border-0 justify-content-center">
      <div class="m-0 d-flex gap-3">
        <app-button  (click)="activeModal.close({title,confirm:false})" [buttonLable]="enumButtonName.NO" [buttonType]="'button'"   [button_2]="true" [buttonClass]="'button button-info popup-button'" ></app-button>
        <app-button  (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.YES" [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-danger  popup-button'"></app-button>
    </div>
    </div>
</div>
<div class="modal-container" *ngSwitchCase="enumPopUpTitles.UNABLE_TO_DELETE">
  <div class="modal-header border-0 justify-content-center">
    <h1 class="modal-title text-center text-danger-color">{{title}}</h1>
  </div>
  <div class="modal-body">
    <div class="text-center">
      <p class="m-0 text-light-gray popup-secondary-text text-truncate my-auto">This category cannot be deleted because it is connected<br>
        to a part record.
      </p>
    </div>
  </div>
  <div class="modal-footer border-0 justify-content-center">
    <div class="m-0 d-flex">
      <app-button [buttonType]="'button'" class=""  [button_2]="true" [buttonClass]="'button button-info popup-button'" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.OKAY"></app-button>
    </div>
  </div>
</div>

<div class="modal-container" *ngSwitchCase="enumPopUpTitles.UNLINK_MANUFACTURER">
  <div class="modal-header border-0 justify-content-center">
    <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
  </div>
  <div class="modal-body">
    <div class="text-center">
      <p class="m-0 text-light-gray popup-secondary-text my-auto"> You are about to remove the link between
        <br>
        <span class="text-break text-primary-color">{{data?.manufacturerData?.manufacturerName}}</span>
        <ng-container *ngIf="data?.manufacturerData?.otherName">
          and <span class="text-break text-primary-color">{{ data?.manufacturerData?.otherName }}</span>
        </ng-container>.
      </p>
      <p class="m-0 text-light-gray popup-secondary-text pt-2">Are you sure you want to proceed?</p>
    </div>
  </div>
  <div class="modal-footer border-0 justify-content-center">
    <div class="m-0 d-flex gap-3">
      <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-info popup-button'" class="" (click)="activeModal.close({title,confirm:false})" [buttonLable]="enumButtonName.CANCEL"></app-button>
      <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-primary popup-button'" class="" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.CONFIRM" (click)="activeModal.close('Close click')"></app-button>
    </div>
  </div>
</div>

<!-- mark as Active -->
<div class="modal-container" *ngSwitchCase="enumPopUpTitles.COMPANY_UNAVAILABLE">
  <div class="modal-header border-0 justify-content-center">
    <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
  </div>
  <div class="modal-body">
    <div class="text-center">
      <p  class="m-0 text-light-gray popup-secondary-text">
       <span class="as-active text-break text-primary-color font-16">{{fullName | titlecase }}</span>
        is not available in the database.<br>
        Press Continue to add the company.</p>
    </div>
  </div>
  <div class="modal-footer border-0 justify-content-center">
    <div class="m-0 d-flex gap-3">
      <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-info popup-button'" class="" (click)="activeModal.close({title,confirm:false});closedPopup()" [buttonLable]="enumButtonName.CANCEL"></app-button>
      <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-primary popup-button'" class="" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.CONTINUE" (click)="activeModal.close('Close click')"></app-button>
    </div>
  </div>
</div>
<!-- Mark as active end  -->

<!-- mark as Active -->
<div class="modal-container" *ngSwitchCase="enumPopUpTitles.REMOVE_APPROVAL">
  <div class="modal-header border-0 justify-content-center">
    <h1 class="modal-title text-center text-danger-color">{{title}}</h1>
  </div>
  <div class="modal-body">
    <div class="text-center">
     <p class="m-0 text-light-gray popup-secondary-text"> This action will remove the prioritization and approval from this source for this requirement. <br>
Are you sure you want to remove approval?
          </p>
    </div>
  </div>
  <div class="modal-footer border-0 justify-content-center">
    <div class="m-0 d-flex gap-3">
      <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-info popup-button'" class="" (click)="activeModal.close({title,confirm:false});closedPopup()" [buttonLable]="enumButtonName.CANCEL"></app-button>
      <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-danger popup-button'" class="" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.REMOVE" (click)="activeModal.close('Close click')"></app-button>
    </div>
  </div>
</div>
<!-- Mark as active end  -->
<!-- EXTEND_EXPIRATION_DATE -->
<div class="modal-container d-flex flex-column h-100" *ngSwitchCase="enumPopUpTitles.EXTEND_EXPIRATION_DATE">
    <div class="modal-header border-0">
      <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
    </div>
    <div class="modal-body">
        <p class="m-0 text-light-gray font-14 mb-1">Part Number : {{data?.partNumber}}</p>
        <p class="m-0 text-light-gray font-14 mb-1">Date Offered : {{data?.dateOffered}}</p>
        <p class="m-0 text-light-gray font-14 mb-1">Vendor : {{data?.vendor}}</p>
        <p class="m-0 text-light-gray font-14 mb-1">Current Expiration Date : {{formattedExpirationDate || ''}}</p>
      <div class="row pt-3">
        <div class="col-12">
          <app-date-picker 
          [time]="false"
          [inputReqValidation]="true"
          [inputLabel]="'Select New Expiration Date'"
          [inputValue]="data.expirationDate"
          (inputValueEmit)="onExpirationDateChange($event)"
          [ngClass]="{'border-red':!data.expirationDate && data?.submit}"
          [minDate]="minDate"
          >
         </app-date-picker>
        </div>
      </div>
    </div>
    <div class="modal-footer border-0 justify-content-center">
      <div class="m-0 d-flex gap-3">
        <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-info popup-button'" class="" (click)="activeModal.close({title,confirm:false})" [buttonLable]="enumButtonName.CANCEL"></app-button>
        <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-primary popup-button'" class="" (click)="activeModal.close({title,confirm:true,expirationDate : formattedExpirationDate})" [buttonLable]="enumButtonName.SAVE"></app-button>
      </div>
    </div>
</div>
<!-- EXTEND_EXPIRATION_DATE END -->

<!-- COMMON -->
<div class="modal-container" *ngSwitchCase="enumPopUpTitles.COMMON">
    <div class="modal-header border-0  justify-content-center">
      <h1 class="modal-title text-center text-primary-color">{{data?.title}}</h1>
    </div>
    <div class="modal-body">
        <p class="m-0 text-light-gray text-center font-14 mb-1">{{data?.description}}</p>
    </div>
    <div class="modal-footer border-0 justify-content-center">
      <div class="m-0 d-flex gap-3">
        <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-info popup-button'" class="" (click)="activeModal.close({title,confirm:false})" [buttonLable]="enumButtonName.CANCEL"></app-button>
        <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-primary popup-button'" class="" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.OK"></app-button>
      </div>
    </div>
</div>
<!-- COMMON END -->

<div class="modal-container" *ngSwitchCase="enumPopUpTitles.MULTIPLE_CUSTOMER_SELECTED">
  <div class="modal-header border-0 justify-content-center">
    <h1 class="modal-title text-center text-danger-color">{{title}}</h1>
  </div>
  <div class="modal-body">
    <div class="text-center">
      <p class="m-0 text-light-gray popup-secondary-text my-auto">You cannot create a quote for more than <br> one customer at a time. Please update your selection and try again.</p>
    </div>
  </div>
  <div class="modal-footer border-0 justify-content-center">
    <div class="m-0 d-flex">
      <app-button [buttonType]="'button'" class=""  [button_2]="true" [buttonClass]="'button button-primary popup-button'" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.OK"></app-button>
    </div>
  </div>
</div>

<div class="modal-container" *ngSwitchCase="enumPopUpTitles.CONFIRM_QUICK_SOURCING">
    <div class="modal-header border-0  justify-content-center">
      <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
    </div>
    <div class="modal-body">
        <p class="m-0 text-light-gray text-center popup-secondary-text mb-1">This action will add all vendors listed as potential sources for each requirement line to the RFQ.</p>
        <p class="m-0 text-light-gray text-center popup-secondary-text mb-1">You will then be advanced to the Send RFQs step. Do you wish to proceed?</p>
    </div>
    <div class="modal-footer border-0 justify-content-center">
      <div class="m-0 d-flex gap-3">
        <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-info popup-button'" class="" (click)="activeModal.close({title,confirm:false})" [buttonLable]="enumButtonName.CANCEL"></app-button>
        <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-primary popup-button'" class="" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.YES"></app-button>
      </div>
    </div>
</div>

<div class="modal-container" *ngSwitchCase="enumPopUpTitles.CANNOT_MARED_READY">
  <div class="modal-header border-0 justify-content-center">
    <h1 class="modal-title text-center text-danger-color">{{title}}</h1>
  </div>
  <div class="modal-body">
    <div class="text-center">
      <p class="m-0 text-light-gray popup-secondary-text my-auto">A Requirement must have at least one prioritized source to <br> be marked as Ready.</p>
    </div>
  </div>
  <div class="modal-footer border-0 justify-content-center">
    <div class="m-0 d-flex">
      <app-button [buttonType]="'button'" class=""  [button_2]="true" [buttonClass]="'button button-primary popup-button'" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.OK"></app-button>
    </div>
  </div>
</div>

<div class="modal-container" *ngSwitchCase="enumPopUpTitles.REMOVE_RECORD">
  <div class="modal-header border-0 justify-content-center">
    <h1 class="modal-title text-center text-danger-color">{{title}}</h1>
  </div>
  <div class="modal-body">
    <div class="text-center">
     <p class="m-0 px-4 text-light-gray popup-secondary-text"> This action will remove the Requirement from the Sourcing Batch but it will not delete the requirement.<br />
             Are you sure you want to remove this requirement from the sourcing batch?
          </p>
    </div>
  </div>
  <div class="modal-footer border-0 justify-content-center">
    <div class="m-0 d-flex gap-3">
      <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-info popup-button'" class="" (click)="activeModal.close({title,confirm:false});closedPopup()" [buttonLable]="enumButtonName.CANCEL"></app-button>
      <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button button-danger popup-button'" class="" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.REMOVE" (click)="activeModal.close('Close click')"></app-button>
    </div>
  </div>
</div>

<div class="modal-container" *ngSwitchCase="enumPopUpTitles.ADD_VENDOR_TO_RFQ_LIST">
  <div class="modal-header border-0 justify-content-center">
    <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
  </div>
  <div class="modal-body">
    <div class="text-center">
     <p class="m-0 px-4 text-light-gray popup-secondary-text`"> Are you sure you want to add this vendor to the RFQ list for this Requirement? </p>
    </div>
  </div>
  <div class="modal-footer border-0 justify-content-center">
    <div class="m-0 d-flex gap-3">
      <app-button [buttonType]="'button'" [button_2]="true" [buttonClass]="'button button-info popup-button'" class="" (click)="activeModal.close({title,confirm:false});closedPopup()" [buttonLable]="enumButtonName.CANCEL"></app-button>
      <app-button [buttonType]="'button'" [button_2]="true" [buttonClass]="'button button-primary popup-button'" class="" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.YES"></app-button>
    </div>
  </div>
</div>

<div class="modal-container" *ngSwitchCase="enumPopUpTitles.REMOVE_VENDOR_FROM_RFQ_LIST">
  <div class="modal-header border-0 justify-content-center">
    <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
  </div>
  <div class="modal-body">
    <div class="text-center">
     <p class="m-0 px-4 text-light-gray popup-secondary-text"> Are you sure you want to remove this vendor from the RFQ list for this Requirement? </p>
    </div>
  </div>
  <div class="modal-footer border-0 justify-content-center">
    <div class="m-0 d-flex gap-3">
      <app-button [buttonType]="'button'" [button_2]="true" [buttonClass]="'button button-info popup-button'" class="" (click)="activeModal.close({title,confirm:false});closedPopup()" [buttonLable]="enumButtonName.CANCEL"></app-button>
      <app-button [buttonType]="'button'" [button_2]="true" [buttonClass]="'button button-primary popup-button'" class="" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.YES"></app-button>
    </div>
  </div>
</div>

<div class="modal-container" *ngSwitchCase="enumPopUpTitles.MARK_VENDOR_AS_NO_BID">
  <div class="modal-header border-0 justify-content-center">
    <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
  </div>
  <div class="modal-body">
    <div class="text-center">
     <p class="m-0 px-4 text-light-gray popup-secondary-text"> You are about to add a No Bid result for this vendor. Do you want to proceed? </p>
    </div>
  </div>
  <div class="modal-footer border-0 justify-content-center">
    <div class="m-0 d-flex gap-3">
      <app-button [buttonType]="'button'" [button_2]="true" [buttonClass]="'button button-info popup-button '" class="" (click)="activeModal.close({title,confirm:false});closedPopup()" [buttonLable]="enumButtonName.CANCEL"></app-button>
      <app-button [buttonType]="'button'" [button_2]="true" [buttonClass]="'button button-primary popup-button'" class="" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.OK"></app-button>
    </div>
  </div>
</div>

<div class="modal-container" *ngSwitchCase="enumPopUpTitles.MARK_AS_PART_NOT_AVAILABLE">
  <div class="modal-header border-0 justify-content-center">
    <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
  </div>
  <div class="modal-body">
    <div class="text-center">
     <p class="m-0 px-4 text-light-gray popup-secondary-text"> You are about to add a Part Not Available result for this vendor. Do you want to proceed? </p>
    </div>
  </div>
  <div class="modal-footer border-0 justify-content-center">
    <div class="m-0 d-flex gap-3">
      <app-button [buttonType]="'button'" [button_2]="true" [buttonClass]="'button button-info popup-button'" class="" (click)="activeModal.close({title,confirm:false});closedPopup()" [buttonLable]="enumButtonName.CANCEL"></app-button>
      <app-button [buttonType]="'button'" [button_2]="true" [buttonClass]="'button button-primary popup-button'" class="" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.OK"></app-button>
    </div>
  </div>
</div>

<div class="modal-container" *ngSwitchCase="enumPopUpTitles.REMOVE_OFFER_APPROVAL">
  <div class="modal-header border-0 justify-content-center">
    <h1 class="modal-title text-center text-danger-color">{{title}}</h1>
  </div>
  <div class="modal-body">
    <div class="text-center">
     <p class="m-0 px-4 text-light-gray popup-secondary-text"> Are you sure you want to remove the approval of the offer from {{data?.companyName}}? </p>
    </div>
  </div>
  <div class="modal-footer border-0 justify-content-center">
    <div class="m-0 d-flex gap-3">
      <app-button [buttonType]="'button'" [button_2]="true" [buttonClass]="'button button-info popup-button'" class="" (click)="activeModal.close({title,confirm:false});closedPopup()" [buttonLable]="enumButtonName.CANCEL"></app-button>
      <app-button [buttonType]="'button'" [button_2]="true" [buttonClass]="'button button-danger popup-button'" class="" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.REMOVE"></app-button>
    </div>
  </div>
</div>

<div class="modal-container" *ngSwitchCase="enumPopUpTitles.OFFER_EXPIRES_SOON">
  <div class="modal-header border-0 justify-content-center">
    <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
  </div>
  <div class="modal-body">
    <div class="text-center">
     <p class="m-0 px-4 text-light-gray popup-secondary-text"> You approved a source that expires in 48 hours. Please click OK to continue or Cancel to revise your selection. </p>
    </div>
  </div>
  <div class="modal-footer border-0 justify-content-center">
    <div class="m-0 d-flex gap-3">
      <app-button [buttonType]="'button'" [button_2]="true" [buttonClass]="'button button-info popup-button'" class="" (click)="activeModal.close({title,confirm:false});closedPopup()" [buttonLable]="enumButtonName.CANCEL"></app-button>
      <app-button [buttonType]="'button'" [button_2]="true" [buttonClass]="'button button-primary popup-button'" class="" (click)="activeModal.close({title,confirm:true})" [buttonLable]="enumButtonName.OK"></app-button>
    </div>
  </div>
</div>

<div class="modal-container d-flex flex-column h-100" *ngSwitchCase="enumPopUpTitles.CONFIRM_QUANTITY_TO_PURCHASE">
  <div class="modal-header border-0">
    <h1 class="modal-title text-center text-primary-color">{{title}}</h1>
  </div>
  <div class="modal-body">
    <div class="text-center">
      <p class="text-light-gray popup-secondary-text"> To complete prioritization, please confirm the quantity to purchase from this source. </p>
    </div>
    <div class="row mt-3">
      <div class="col">
        <p class="m-0 text-light-gray font-14 mb-1">Required Qty: {{data?.requiredQty}}</p>
      </div>
      <div class="col">
        <p class="m-0 text-light-gray font-14 mb-1">Balance Qty: {{data?.balanceQty}}</p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <p class="m-0 text-light-gray font-14 mb-1">SPQ: {{data?.spq}}</p>
      </div>
    </div>
    <div class="row mt-3">
      <p class="m-0 text-light-gray font-14 mb-1 fw-bold">Vendor Qty</p>
      <div class="col">
        <p class="m-0 text-light-gray font-14 mb-1">Offered: {{data?.offered}}</p>
      </div>
      <div class="col">
        <p class="m-0 text-light-gray font-14 mb-1">Available: {{data?.available}}</p>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <label for="" class="text-light-gray hand font-14">Quantity to Purchase<i class="fst-normal ps-1 p-0 text-danger">*</i></label>
        <app-input [inputLabel]="''" [inputType]="'text'" class="qty-input"
          [inputValue]="data.quantityToPurchase" onlyNumbers (inputValueEmit)="data.quantityToPurchase = $event">
        </app-input>
      </div>
    </div>
  </div>
  <div class="modal-footer border-0 justify-content-center">
    <div class="m-0 d-flex gap-3">
      <app-button [buttonType]="'button'" [button_2]="true" [buttonClass]="'button button-info popup-button'" class="" (click)="activeModal.close({title,confirm:false})" [buttonLable]="enumButtonName.CANCEL"></app-button>
      <app-button [buttonType]="'button'" [button_2]="true" [buttonClass]="'button button-primary popup-button'" class="" (click)="activeModal.close({title,confirm:true,quantityToPurchase : data.quantityToPurchase})" [buttonLable]="enumButtonName.SAVE"></app-button>
    </div>
  </div>
</div>

</ng-container>
